import React, { useRef, useEffect, useState } from "react";
import { useApiIsLoaded, useMapsLibrary } from '@vis.gl/react-google-maps';
import InputText from "../../Form/InputText";
import classNames from "classnames";

export default function GeoSearchBox(props) {
    const {
        value,
        label,
        types,
        restrictions,
        loadMap,
        handleLoad,
        handleInputChange,
        onEnter = () => {},
        handlePlaceChanged,
        focusOnInput,
        className,
        dataTestId,
    } = props;

    const inputRef = useRef(null);
    const places = useMapsLibrary('places');
    const [placeAutocomplete, setPlaceAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
    const apiIsLoaded = useApiIsLoaded();

    useEffect(() => {
        if (apiIsLoaded && places)
            handleLoad(inputRef);
    }, [inputRef, apiIsLoaded, places]);

    useEffect(() => {
        if (!places || !inputRef.current) return;

        const options = {
            fields: ['geometry', 'name', 'formatted_address'],
            componentRestrictions: restrictions,
            types
        };

        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);

    useEffect(() => {
        if (!placeAutocomplete) return;

        placeAutocomplete.addListener('place_changed', () => {
            handlePlaceChanged(placeAutocomplete.getPlace());
        });
    }, [handlePlaceChanged, placeAutocomplete]);


    useEffect(() => {
        if (focusOnInput) {
            inputRef.current.focus();
        }
    }, [focusOnInput]);

    function onKeydown(e) {
        if (e.which === 13) {
            e.preventDefault();
            onEnter();
        }
    }

    if (loadMap) {
        return (
            <div className="flex-grow-1">
                <InputText
                    inputRef={inputRef}
                    className={classNames("form-control has-label border-0", className)}
                    inputFieldName="geosearch"
                    inputLabel={label}
                    onChange={handleInputChange}
                    inputDefaultValue={value}
                    onKeyDown={onKeydown}
                    dataTestId={dataTestId}
                    />
            </div>
        );
    } else {
        return (
            <div className="bg-gray-200">Search is not enabled</div>
        );
    }
}